import { jsPDF } from 'jspdf';
import { useCallback, useRef } from 'react';
import { DownloadType } from 'types';
import domtoimage from 'dom-to-image';

export const useDownloadCountryReport = () => {
  const divRef = useRef<HTMLDivElement>(null);

  const generateImage = async () => {
    if (divRef !== null && divRef?.current) {
      return await domtoimage.toPng(divRef.current, { bgcolor: '#ffffff' }).then((dataUrl) => dataUrl);
    }
  };

  const handleDownload = useCallback(
    async (
      type: DownloadType,
      configuration: {
        fileName: string;
        orientation?: 'portrait' | 'landscape';
        isSquareDownload?: boolean;
      },
    ) => {

      const { fileName, orientation } = configuration;

      try {
        await new Promise((resolve) => setTimeout(resolve, 0));
        const image = await generateImage();
        if (image) {
          const img = new Image();
          img.src = image;

          img.onload = () => {
            const A4_WIDTH = 210; // A4 width in mm
            const imgWidth = img.width;
            const imgHeight = img.height;

            // Calculate the scaled height for the image to maintain its aspect ratio
            const scaleFactor = A4_WIDTH / imgWidth;
            const scaledHeight = imgHeight * scaleFactor;

            // Create a PDF with dynamic height based on the scaled image
            const pdf = new jsPDF({
              orientation: orientation || 'portrait',
              unit: 'mm',
              format: [A4_WIDTH, scaledHeight],
            });

            // Add the image to the top-left corner of the PDF
            pdf.addImage(image, 'PNG', 0, 0, A4_WIDTH, scaledHeight);

            // Save the PDF
            pdf.save(`${fileName}.pdf`);
          };
        }
      } catch (error) {
        console.error('Error generating PDF:', error);
      }
    },
    [divRef, generateImage],
  );

  return { handleDownload, divRef };
};

